/**
 * Route component for /kwiaty/:handle and /okazje/:handle.
 * If the handle has a hero config → CategoryCollectionPage with hero.
 * Otherwise → generic CollectionPage (no hero).
 */
import { useLocation, useParams } from 'wouter';
import { lazy, Suspense } from 'react';
import { categoryConfigMap } from './dynamicCategoryConfigs';
import { handleFromPublicUrl } from '@/lib/collectionUrl';

const CategoryCollectionPage = lazy(() => import('./CategoryCollectionPage'));
const CollectionPage         = lazy(() => import('./collection'));

export default function DynamicCategoryPage() {
  const params = useParams<{ handle: string }>();
  const [location] = useLocation();
  const handle = handleFromPublicUrl(location) ?? params?.handle ?? '';
  const config = categoryConfigMap[handle];

  if (config) {
    return (
      <Suspense fallback={null}>
        <CategoryCollectionPage config={config} />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={null}>
      <CollectionPage fixedHandle={handle} />
    </Suspense>
  );
}
